
// import React, { useState, useEffect } from 'react';
// import {
//   ThemeProvider,
//   createTheme,
//   Box,
//   Typography,
//   Container,
//   CssBaseline,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Snackbar,
//   Alert,
//   Menu,
//   MenuItem,
//   ListItemText,
//   IconButton,
//   CircularProgress
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import axios from 'axios';
 
// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#000000',
//     },
//     secondary: {
//       main: '#dc004e',
//     },
//     background: {
//       default: '#ffffff',
//     },
//   },
//   typography: {
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//     h1: {
//       fontWeight: 700,
//     },
//     h2: {
//       fontWeight: 600,
//     },
//   },
//   components: {
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//         },
//       },
//     },
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//         },
//       },
//     },
//   },
// });
 
// function Student() {
//   const [rows, setRows] = useState([]);
//   const [filteredRows, setFilteredRows] = useState([]);
//   const [pageSize, setPageSize] = useState(10);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [selectedParticipant, setSelectedParticipant] = useState(null);
//   const [action, setAction] = useState('');
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');
//   const [filterMenuAnchor, setFilterMenuAnchor] = useState(null);
//   const [activeFilter, setActiveFilter] = useState(null);
//   const [filterValue, setFilterValue] = useState('');
//   const [loading, setLoading] = useState(true);
 
//   useEffect(() => {
//     fetchData();
//   }, []);
 
//   const fetchData = async () => {
//     try {
//       const response = await axios.get('https://newbackend.elephant-tank.com/api/verified_students/');
//       const formattedData = response.data.map((item, index) => ({
//         id: index + 1,
//         ...item,
//       }));
//       setRows(formattedData);
//       setFilteredRows(formattedData);
//       setLoading(false);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       setSnackbarMessage('Error fetching data. Please try again.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//       setLoading(false);
//     }
//   };
 
//   const handleAction = (id, actionType) => {
//     setSelectedParticipant(rows.find(row => row.id === id));
//     setAction(actionType);
//     setDialogOpen(true);
//   };
 
//   const handleConfirmAction = async () => {
//     try {
//       const endpoint = 'https://newbackend.elephant-tank.com/api/students_approval/';
//       const payload = {
//         student_id: [selectedParticipant.id.toString()], // Sending ID as an array
//         status: action,
//       };
  
//       const response = await axios.patch(endpoint, payload);
  
//       if (response.status === 200) {
//         const newRows = rows.map(row => {
//           if (row.id === selectedParticipant.id) {
//             return { ...row, status: action };
//           }
//           return row;
//         });
//         setRows(newRows);
//         setFilteredRows(newRows);
//         setDialogOpen(false);
  
//         setSnackbarMessage(response.data.msg || 'Student status updated successfully.');
//         setSnackbarSeverity(action === 'accept' ? 'success' : 'error');
//         setSnackbarOpen(true);
//       } else {
//         throw new Error('Unexpected response status');
//       }
//     } catch (error) {
//       console.error('Error updating student status:', error);
//       setSnackbarMessage('Error updating student status. Please try again.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     }
//   };
  
//   const handleFilterMenuOpen = (event) => {
//     setFilterMenuAnchor(event.currentTarget);
//   };
 
//   const handleFilterMenuClose = () => {
//     setFilterMenuAnchor(null);
//   };
 
//   const handleFilterSelect = (field) => {
//     setActiveFilter(field);
//     handleFilterMenuClose();
//   };
 
//   const handleFilterChange = (event) => {
//     setFilterValue(event.target.value);
//   };
 
//   const applyFilter = () => {
//     if (activeFilter && filterValue) {
//       const filtered = rows.filter(row =>
//         row[activeFilter]?.toString().toLowerCase().includes(filterValue.toLowerCase())
//       );
//       setFilteredRows(filtered);
//     } else {
//       setFilteredRows(rows);
//     }
//   };
 
//   useEffect(() => {
//     applyFilter();
//   }, [filterValue, activeFilter, rows]);
 
//   const columns = [
//     { field: 'full_name', headerName: 'Full Name', flex: 1, minWidth: 150 },
//     { field: 'email', headerName: 'Email', flex: 1, minWidth: 200 },
//     { field: 'phone_number', headerName: 'Phone Number', flex: 1, minWidth: 150 },
//     { field: 'institution', headerName: 'Institution', flex: 1, minWidth: 150 },
//     { field: 'field_of_study', headerName: 'Field of Study', flex: 1, minWidth: 150 },
//     { field: 'graduation_year', headerName: 'Graduation Year', flex: 1, minWidth: 150 },
//     { field: 'status', headerName: 'Status', flex: 1, minWidth: 120 },
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       flex: 1,
//       minWidth: 200,
//       sortable: false,
//       renderCell: (params) => (
//         <Box>
//           {params.row.status !== 'accept' && (
//             <Button
//               variant="contained"
//               color="background"
//               size="small"
//               onClick={() => handleAction(params.row.id, 'accept')}
//               sx={{ mr: 1 }}
//             >
//               {params.row.status === 'accept' ? 'Accepted' : 'Accept'}
//             </Button>
//           )}
//           {params.row.status !== 'denied' && (
//             <Button
//               variant="contained"
//               color="secondary"
//               size="small"
//               onClick={() => handleAction(params.row.id, 'denied')}
//             >
//               {params.row.status === 'denied' ? 'Rejected' : 'Denied'}
//             </Button>
//           )}
//         </Box>
//       ),
//     },
//   ];
 
//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
//         <Container maxWidth={false} sx={{ mt: 4, mb: 4, flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 5 }}>
//           <Typography
//         variant="h4"
//         sx={{
//           mb: 4,
//           fontWeight: "bold",
//           color: "#37474f",
//           textAlign: "center",
//         }}
//       >
//               Verified Students Dashboard
//               </Typography>
//             <Box>
//               <IconButton onClick={handleFilterMenuOpen}>
//                 <FilterListIcon />
//               </IconButton>
//               <Menu
//                 anchorEl={filterMenuAnchor}
//                 open={Boolean(filterMenuAnchor)}
//                 onClose={handleFilterMenuClose}
//               >
//                 {columns.map((column) => (
//                   <MenuItem key={column.field} onClick={() => handleFilterSelect(column.field)}>
//                     <ListItemText primary={column.headerName} />
//                   </MenuItem>
//                 ))}
//               </Menu>
//               {activeFilter && (
//                 <Box component="form" onSubmit={(e) => { e.preventDefault(); applyFilter(); }} sx={{ display: 'flex', alignItems: 'center' }}>
//                   <Typography variant="body2" sx={{ mr: 1 }}>
//                     Filter by {columns.find(col => col.field === activeFilter)?.headerName}:
//                   </Typography>
//                   <input
//                     type="text"
//                     value={filterValue}
//                     onChange={handleFilterChange}
//                     placeholder="Enter filter value"
//                     style={{ marginRight: '8px', padding: '4px' }}
//                   />
//                   <Button type="submit" variant="contained" size="small">
//                     Apply
//                   </Button>
//                 </Box>
//               )}
//             </Box>
//           </Box>
//           <Box sx={{
//             flexGrow: 1,
//             width: '100%',
//             bgcolor: 'background.paper',
//             borderRadius: 4,
//             overflow: 'hidden',
//             boxShadow: 3,
//             '& .MuiDataGrid-root': {
//               border: 'none',
//             },
//             '& .MuiDataGrid-cell': {
//               borderBottom: 'none',
//             },
//             '& .MuiDataGrid-columnHeaders': {
//               backgroundColor: theme.palette.primary.main,
//               color: '#000000',
//               fontSize: 16,
//             },
//             '& .MuiDataGrid-virtualScroller': {
//               backgroundColor: theme.palette.background.paper,
//             },
//             '& .MuiDataGrid-footerContainer': {
//               borderTop: 'none',
//               backgroundColor: theme.palette.background.paper,
//             },
//             '& .MuiButton-root': {
//               color: theme.palette.primary.main,
//             },
//           }}>
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%',color:'#333300' }}>
//                 <CircularProgress />
//               </Box>
//             ) : (
//               <DataGrid
//                 rows={filteredRows}
//                 columns={columns}
//                 pageSize={pageSize}
//                 onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
//                 rowsPerPageOptions={[5, 10, 20]}
//                 pagination
//                 disableSelectionOnClick
//                 autoHeight
//               />
//             )}
//           </Box>
//         </Container>
//       </Box>
 
//       <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
//         <DialogTitle>{`${action === 'accept' ? 'Accept' : 'Deny'} Participant`}</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to {action} {selectedParticipant?.full_name}?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
//           <Button onClick={handleConfirmAction} autoFocus>
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>
 
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </ThemeProvider>
//   );
// }
 
// export default Student;

// import React, { useState, useEffect } from 'react';
// import {
//   ThemeProvider,
//   createTheme,
//   Box,
//   Typography,
//   Container,
//   CssBaseline,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Snackbar,
//   Alert,
//   Menu,
//   MenuItem,
//   ListItemText,
//   IconButton,
//   CircularProgress,
//   Pagination,
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import axios from 'axios';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#000000',
//     },
//     secondary: {
//       main: '#dc004e',
//     },
//     background: {
//       default: '#ffffff',
//     },
//   },
//   typography: {
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//     h1: {
//       fontWeight: 700,
//     },
//     h2: {
//       fontWeight: 600,
//     },
//   },
//   components: {
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//         },
//       },
//     },
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//         },
//       },
//     },
//   },
// });

// function Student() {
//   const [rows, setRows] = useState([]);
//   const [filteredRows, setFilteredRows] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [selectedParticipant, setSelectedParticipant] = useState(null);
//   const [action, setAction] = useState('');
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');
//   const [filterMenuAnchor, setFilterMenuAnchor] = useState(null);
//   const [activeFilter, setActiveFilter] = useState(null);
//   const [filterValue, setFilterValue] = useState('');
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get('https://newbackend.elephant-tank.com/api/verified_students/');
//       const formattedData = response.data.map((item, index) => ({
//         id: index + 1,
//         ...item,
//       }));
//       setRows(formattedData);
//       setFilteredRows(formattedData);
//       setLoading(false);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       setSnackbarMessage('Error fetching data. Please try again.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//       setLoading(false);
//     }
//   };

//   const handleAction = (id, actionType) => {
//     setSelectedParticipant(rows.find((row) => row.id === id));
//     setAction(actionType);
//     setDialogOpen(true);
//   };

//   const handleConfirmAction = async () => {
//     try {
//       const endpoint = 'https://newbackend.elephant-tank.com/api/students_approval/';
//       const payload = {
//         student_id: [selectedParticipant.id.toString()],
//         status: action,
//       };

//       const response = await axios.patch(endpoint, payload);

//       if (response.status === 200) {
//         const newRows = rows.map((row) => {
//           if (row.id === selectedParticipant.id) {
//             return { ...row, status: action };
//           }
//           return row;
//         });
//         setRows(newRows);
//         setFilteredRows(newRows);
//         setDialogOpen(false);

//         setSnackbarMessage(response.data.msg || 'Student status updated successfully.');
//         setSnackbarSeverity(action === 'accept' ? 'success' : 'error');
//         setSnackbarOpen(true);
//       } else {
//         throw new Error('Unexpected response status');
//       }
//     } catch (error) {
//       console.error('Error updating student status:', error);
//       setSnackbarMessage('Error updating student status. Please try again.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     }
//   };

//   const handleFilterMenuOpen = (event) => {
//     setFilterMenuAnchor(event.currentTarget);
//   };

//   const handleFilterMenuClose = () => {
//     setFilterMenuAnchor(null);
//   };

//   const handleFilterSelect = (field) => {
//     setActiveFilter(field);
//     handleFilterMenuClose();
//   };

//   const handleFilterChange = (event) => {
//     setFilterValue(event.target.value);
//   };

//   const applyFilter = () => {
//     if (activeFilter && filterValue) {
//       const filtered = rows.filter((row) =>
//         row[activeFilter]?.toString().toLowerCase().includes(filterValue.toLowerCase())
//       );
//       setFilteredRows(filtered);
//     } else {
//       setFilteredRows(rows);
//     }
//   };

//   useEffect(() => {
//     applyFilter();
//   }, [filterValue, activeFilter, rows]);

//   const handlePageChange = (event, newPage) => {
//     setCurrentPage(newPage);
//   };

//   const paginatedRows = filteredRows.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//   const columns = [
//     { field: 'full_name', headerName: 'Full Name', flex: 1, minWidth: 150 },
//     { field: 'email', headerName: 'Email', flex: 1, minWidth: 200 },
//     { field: 'phone_number', headerName: 'Phone Number', flex: 1, minWidth: 150 },
//     { field: 'institution', headerName: 'Institution', flex: 1, minWidth: 150 },
//     { field: 'field_of_study', headerName: 'Field of Study', flex: 1, minWidth: 150 },
//     { field: 'graduation_year', headerName: 'Graduation Year', flex: 1, minWidth: 150 },
//     { field: 'status', headerName: 'Status', flex: 1, minWidth: 120 },
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       flex: 1,
//       minWidth: 200,
//       sortable: false,
//       renderCell: (params) => (
//         <Box>
//           {params.row.status !== 'accept' && (
//             <Button
//               variant="contained"
//               color="background"
//               size="small"
//               onClick={() => handleAction(params.row.id, 'accept')}
//               sx={{ mr: 1 }}
//             >
//               {params.row.status === 'accept' ? 'Accepted' : 'Accept'}
//             </Button>
//           )}
//           {params.row.status !== 'denied' && (
//             <Button
//               variant="contained"
//               color="secondary"
//               size="small"
//               onClick={() => handleAction(params.row.id, 'denied')}
//             >
//               {params.row.status === 'denied' ? 'Rejected' : 'Denied'}
//             </Button>
//           )}
//         </Box>
//       ),
//     },
//   ];

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: 'column',
//           height: '100vh',
//           overflow: 'hidden',
//         }}
//       >
//         <Container
//           maxWidth={false}
//           sx={{
//             mt: 4,
//             mb: 4,
//             flexGrow: 1,
//             display: 'flex',
//             flexDirection: 'column',
//             overflow: 'hidden',
//           }}
//         >
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               mb: 2,
//               mt: 5,
//             }}
//           >
//             <Typography
//               variant="h4"
//               sx={{
//                 mb: 4,
//                 fontWeight: 'bold',
//                 color: '#37474f',
//                 textAlign: 'center',
//               }}
//             >
//               Verified Students Dashboard
//             </Typography>
//             <Box>
//               <IconButton onClick={handleFilterMenuOpen}>
//                 <FilterListIcon />
//               </IconButton>
//               <Menu
//                 anchorEl={filterMenuAnchor}
//                 open={Boolean(filterMenuAnchor)}
//                 onClose={handleFilterMenuClose}
//               >
//                 {columns.map((column) => (
//                   <MenuItem
//                     key={column.field}
//                     onClick={() => handleFilterSelect(column.field)}
//                   >
//                     <ListItemText primary={column.headerName} />
//                   </MenuItem>
//                 ))}
//               </Menu>
//               {activeFilter && (
//                 <Box
//                   component="form"
//                   onSubmit={(e) => {
//                     e.preventDefault();
//                     applyFilter();
//                   }}
//                   sx={{ display: 'flex', alignItems: 'center' }}
//                 >
//                   <Typography variant="body2" sx={{ mr: 1 }}>
//                     Filter by {columns.find((col) => col.field === activeFilter)?.headerName}:
//                   </Typography>
//                   <input
//                     type="text"
//                     value={filterValue}
//                     onChange={handleFilterChange}
//                     placeholder="Enter filter value"
//                     style={{ marginRight: '8px', padding: '4px' }}
//                   />
//                   <Button type="submit" variant="contained" size="small">
//                     Apply
//                   </Button>
//                 </Box>
//               )}
//             </Box>
//           </Box>
//           <Box
//             sx={{
//               flexGrow: 1,
//               width: '100%',
//               bgcolor: 'background.paper',
//               borderRadius: 4,
//               overflow: 'hidden',
//               boxShadow: 3,
//               '& .MuiDataGrid-root': {
//                 border: 'none',
//               },
//               '& .MuiDataGrid-cell': {
//                 borderBottom: 'none',
//               },
//               '& .MuiDataGrid-columnHeaders': {
//                 backgroundColor: theme.palette.primary.main,
//                 color: '#000000',
//                 fontSize: 16,
//               },
//               '& .MuiDataGrid-virtualScroller': {
//                 backgroundColor: theme.palette.background.paper,
//               },
//               '& .MuiDataGrid-footerContainer': {
//                 borderTop: 'none',
//                 backgroundColor: theme.palette.background.paper,
//               },
//               '& .MuiButton-root': {
//                 color: theme.palette.primary.main,
//               },
//             }}
//           >
//             {loading ? (
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'center',
//                   alignItems: 'center',
//                   height: '100%',
//                   color: '#333300',
//                 }}
//               >
//                 <CircularProgress />
//               </Box>
//             ) : (
//               <DataGrid
//                 rows={paginatedRows}
//                 columns={columns}
//                 pageSize={rowsPerPage}
//                 disableSelectionOnClick
//                 autoHeight
//                 rowCount={filteredRows.length}
//                 paginationMode="server"
//               />
//             )}
//           </Box>
          
//           <Pagination
//             count={Math.ceil(filteredRows.length / rowsPerPage)}
//             page={currentPage}
//             onChange={handlePageChange}
//             color="primary"
//             sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}
//           />
//         </Container>
//       </Box>

//       <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
//         <DialogTitle>{`${action === 'accept' ? 'Accept' : 'Deny'} Participant`}</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to {action} {selectedParticipant?.full_name}?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
//           <Button onClick={handleConfirmAction} autoFocus>
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: '100%' }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </ThemeProvider>
//   );
// }

// export default Student;
 
// import React, { useState, useEffect } from 'react';
// import {
//   ThemeProvider,
//   createTheme,
//   Box,
//   Typography,
//   Container,
//   CssBaseline,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Snackbar,
//   Alert,
//   Menu,
//   MenuItem,
//   ListItemText,
//   IconButton,
//   CircularProgress,
//   Pagination,
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import axios from 'axios';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#000000',
//     },
//     secondary: {
//       main: '#dc004e',
//     },
//     background: {
//       default: '#ffffff',
//     },
//   },
//   typography: {
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//     h1: {
//       fontWeight: 700,
//     },
//     h2: {
//       fontWeight: 600,
//     },
//   },
//   components: {
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//         },
//       },
//     },
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//         },
//       },
//     },
//   },
// });

// function Student() {
//   const [rows, setRows] = useState([]);
//   const [filteredRows, setFilteredRows] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [selectedParticipant, setSelectedParticipant] = useState(null);
//   const [action, setAction] = useState('');
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');
//   const [filterMenuAnchor, setFilterMenuAnchor] = useState(null);
//   const [activeFilter, setActiveFilter] = useState(null);
//   const [filterValue, setFilterValue] = useState('');
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get('https://newbackend.elephant-tank.com/api/verified_students/');
//       const formattedData = response.data.map((item, index) => ({
//         id: index + 1,
//         ...item,
//       }));
//       setRows(formattedData);
//       setFilteredRows(formattedData);
//       setLoading(false);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       setSnackbarMessage('Error fetching data. Please try again.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//       setLoading(false);
//     }
//   };

//   const handleAction = (id, actionType) => {
//     setSelectedParticipant(rows.find((row) => row.id === id));
//     setAction(actionType);
//     setDialogOpen(true);
//   };

//   const handleConfirmAction = async () => {
//     try {
//       const endpoint = 'https://newbackend.elephant-tank.com/api/students_approval/';
//       const payload = {
//         student_id: [selectedParticipant.id.toString()],
//         status: action,
//       };

//       const response = await axios.patch(endpoint, payload);

//       if (response.status === 200) {
//         const newRows = rows.map((row) => {
//           if (row.id === selectedParticipant.id) {
//             return { ...row, status: action };
//           }
//           return row;
//         });
//         setRows(newRows);
//         setFilteredRows(newRows);
//         setDialogOpen(false);

//         setSnackbarMessage(response.data.msg || 'Student status updated successfully.');
//         setSnackbarSeverity(action === 'accept' ? 'success' : 'error');
//         setSnackbarOpen(true);
//       } else {
//         throw new Error('Unexpected response status');
//       }
//     } catch (error) {
//       console.error('Error updating student status:', error);
//       setSnackbarMessage('Error updating student status. Please try again.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     }
//   };

//   const handleFilterMenuOpen = (event) => {
//     setFilterMenuAnchor(event.currentTarget);
//   };

//   const handleFilterMenuClose = () => {
//     setFilterMenuAnchor(null);
//   };

//   const handleFilterSelect = (field) => {
//     setActiveFilter(field);
//     handleFilterMenuClose();
//   };

//   const handleFilterChange = (event) => {
//     setFilterValue(event.target.value);
//   };

//   const applyFilter = () => {
//     if (activeFilter && filterValue) {
//       const filtered = rows.filter((row) =>
//         row[activeFilter]?.toString().toLowerCase().includes(filterValue.toLowerCase())
//       );
//       setFilteredRows(filtered);
//     } else {
//       setFilteredRows(rows);
//     }
//   };

//   useEffect(() => {
//     applyFilter();
//   }, [filterValue, activeFilter, rows]);

//   const handlePageChange = (event, newPage) => {
//     setCurrentPage(newPage);
//   };

//   const paginatedRows = filteredRows.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//   const columns = [
//     { field: 'full_name', headerName: 'Full Name', flex: 1, minWidth: 150 },
//     { field: 'email', headerName: 'Email', flex: 1, minWidth: 200 },
//     { field: 'phone_number', headerName: 'Phone Number', flex: 1, minWidth: 150 },
//     { field: 'institution', headerName: 'Institution', flex: 1, minWidth: 150 },
//     { field: 'field_of_study', headerName: 'Field of Study', flex: 1, minWidth: 150 },
//     { field: 'graduation_year', headerName: 'Graduation Year', flex: 1, minWidth: 150 },
//     { field: 'status', headerName: 'Status', flex: 1, minWidth: 120 },
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       flex: 1,
//       minWidth: 200,
//       sortable: false,
//       renderCell: (params) => (
//         <Box>
//           {params.row.status !== 'accept' && (
//             <Button
//               variant="contained"
//               color="primary"
//               size="small"
//               onClick={() => handleAction(params.row.id, 'accept')}
//               sx={{ mr: 1 }}
//             >
//               Accept
//             </Button>
//           )}
//           {params.row.status !== 'denied' && (
//             <Button
//               variant="contained"
//               color="secondary"
//               size="small"
//               onClick={() => handleAction(params.row.id, 'denied')}
//             >
//               Deny
//             </Button>
//           )}
//         </Box>
//       ),
//     },
//   ];

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: 'column',
//           height: '100vh',
//           overflow: 'hidden',
//         }}
//       >
//         <Container
//           maxWidth={false}
//           sx={{
//             mt: 4,
//             mb: 4,
//             flexGrow: 1,
//             display: 'flex',
//             flexDirection: 'column',
//             overflow: 'hidden',
//           }}
//         >
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               mb: 2,
//             }}
//           >
//             <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
//               Verified Students Dashboard
//             </Typography>
//             <Box>
//               <IconButton onClick={handleFilterMenuOpen}>
//                 <FilterListIcon />
//               </IconButton>
//               <Menu
//                 anchorEl={filterMenuAnchor}
//                 open={Boolean(filterMenuAnchor)}
//                 onClose={handleFilterMenuClose}
//               >
//                 {columns.map((column) => (
//                   <MenuItem
//                     key={column.field}
//                     onClick={() => handleFilterSelect(column.field)}
//                   >
//                     <ListItemText primary={column.headerName} />
//                   </MenuItem>
//                 ))}
//               </Menu>
//               {activeFilter && (
//                 <Box
//                   component="form"
//                   onSubmit={(e) => {
//                     e.preventDefault();
//                     applyFilter();
//                   }}
//                   sx={{ display: 'flex', alignItems: 'center' }}
//                 >
//                   <Typography variant="body2" sx={{ mr: 1 }}>
//                     Filter by {columns.find((col) => col.field === activeFilter)?.headerName}:
//                   </Typography>
//                   <input
//                     type="text"
//                     value={filterValue}
//                     onChange={handleFilterChange}
//                     placeholder="Enter filter value"
//                     style={{ marginRight: '8px', padding: '4px' }}
//                   />
//                   <Button type="submit" variant="contained" size="small">
//                     Apply
//                   </Button>
//                 </Box>
//               )}
//             </Box>
//           </Box>
//           <Box
//             sx={{
//               flexGrow: 1,
//               width: '100%',
//               bgcolor: 'background.paper',
//               borderRadius: 4,
//               overflow: 'hidden',
//               boxShadow: 3,
//             }}
//           >
//             {loading ? (
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'center',
//                   alignItems: 'center',
//                   height: '100%',
//                 }}
//               >
//                 <CircularProgress />
//               </Box>
//             ) : (
//               <DataGrid
//                 rows={paginatedRows}
//                 columns={columns}
//                 autoHeight
//                 pagination={false}
//                 disableSelectionOnClick
//                 sx={{ border: 'none' }}
//               />
//             )}
//           </Box>
//           <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
//             <Pagination
//               count={Math.ceil(filteredRows.length / rowsPerPage)}
//               page={currentPage}
//               onChange={handlePageChange}
//               color="primary"
//             />
//           </Box>
//         </Container>
//       </Box>

//       {/* Dialog for action confirmation */}
//       <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
//         <DialogTitle>
//           {action === 'accept' ? 'Accept Participant' : 'Deny Participant'}
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to {action === 'accept' ? 'accept' : 'deny'} this participant?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDialogOpen(false)} color="primary">
//             Cancel
//           </Button>
//           <Button
//             onClick={handleConfirmAction}
//             color={action === 'accept' ? 'primary' : 'secondary'}
//             variant="contained"
//           >
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar for feedback */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={() => setSnackbarOpen(false)}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: '100%' }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </ThemeProvider>
//   );
// }

// export default Student;

// import React, { useState, useEffect } from 'react';
// import {
//   ThemeProvider,
//   createTheme,
//   Box,
//   Typography,
//   Container,
//   CssBaseline,
//   Button,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import axios from 'axios';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#000000',
//     },
//     secondary: {
//       main: '#dc004e',
//     },
//   },
//   typography: {
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//   },
// });

// function Student() {
//   const [rows, setRows] = useState([]);
//   const [filteredRows, setFilteredRows] = useState([]);
//   const [filters, setFilters] = useState({
//     institution: '',
//     field_of_study: '',
//     graduation_year: '',
//     status: '',
//   });
//   const [filterOptions, setFilterOptions] = useState({
//     institutions: [],
//     fieldsOfStudy: [],
//     graduationYears: [],
//     statuses: [],
//   });
//   const [pageSize, setPageSize] = useState(10);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [selectedParticipant, setSelectedParticipant] = useState(null);
//   const [action, setAction] = useState('');

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         'https://newbackend.elephant-tank.com/api/verified_students/'
//       );
//       const formattedData = response.data
//         .filter((item) => item.admin_approval === false)
//         .map((item, index) => ({
//           id: index + 1,
//           ...item,
//         }));

//       // Extract unique options for dropdowns
//       const institutions = [...new Set(formattedData.map((item) => item.institution))];
//       const fieldsOfStudy = [...new Set(formattedData.map((item) => item.field_of_study))];
//       const graduationYears = [...new Set(formattedData.map((item) => item.graduation_year))];
//       const statuses = [...new Set(formattedData.map((item) => item.status || ''))];

//       setRows(formattedData);
//       setFilteredRows(formattedData);
//       setFilterOptions({
//         institutions,
//         fieldsOfStudy,
//         graduationYears,
//         statuses,
//       });
//       setLoading(false);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       setSnackbarMessage('Error fetching data. Please try again.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//       setLoading(false);
//     }
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   useEffect(() => {
//     const applyFilters = () => {
//       let filtered = rows;
//       Object.entries(filters).forEach(([key, value]) => {
//         if (value) {
//           filtered = filtered.filter((row) => row[key]?.toString() === value.toString());
//         }
//       });
//       setFilteredRows(filtered);
//     };

//     applyFilters();
//   }, [filters, rows]);

//   const handleAction = (id, actionType) => {
//     setSelectedParticipant(rows.find((row) => row.id === id));
//     setAction(actionType);
//     setDialogOpen(true);
//   };

//   const handleConfirmAction = async () => {
//     try {
//       const endpoint = 'https://newbackend.elephant-tank.com/api/students_approval/';
//       const payload = {
//         student_id: [selectedParticipant.id.toString()],
//         status: action,
//       };

//       const response = await axios.patch(endpoint, payload);

//       if (response.status === 200) {
//         const newRows = rows.map((row) => {
//           if (row.id === selectedParticipant.id) {
//             return { ...row, status: action };
//           }
//           return row;
//         });
//         setRows(newRows);
//         setFilteredRows(newRows);
//         setDialogOpen(false);

//         setSnackbarMessage(response.data.msg || 'Student status updated successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//       } else {
//         throw new Error('Unexpected response status');
//       }
//     } catch (error) {
//       console.error('Error updating student status:', error);
//       setSnackbarMessage('Error updating student status. Please try again.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     }
//   };

//   const columns = [
//     { field: 'full_name', headerName: 'Full Name', flex: 1, minWidth: 150 },
//     { field: 'email', headerName: 'Email', flex: 1, minWidth: 200 },
//     { field: 'phone_number', headerName: 'Phone Number', flex: 1, minWidth: 150 },
//     { field: 'institution', headerName: 'Institution', flex: 1, minWidth: 150 },
//     { field: 'field_of_study', headerName: 'Field of Study', flex: 1, minWidth: 150 },
//     { field: 'graduation_year', headerName: 'Graduation Year', flex: 1, minWidth: 120 },
//     { field: 'status', headerName: 'Status', flex: 1, minWidth: 120 },
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       flex: 1,
//       minWidth: 200,
//       sortable: false,
//       renderCell: (params) => (
//         <Box>
//           <Button
//             variant="contained"
//             color="primary"
//             size="small"
//             onClick={() => handleAction(params.row.id, 'accept')}
//             sx={{ mr: 1 }}
//           >
//             Accept
//           </Button>
//           <Button
//             variant="contained"
//             color="secondary"
//             size="small"
//             onClick={() => handleAction(params.row.id, 'denied')}
//           >
//             Deny
//           </Button>
//         </Box>
//       ),
//     },
//   ];

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
//         <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold', color: '#37474f' }}>
//           Verified Students Dashboard
//         </Typography>
//         <Box
//           sx={{
//             display: 'flex',
//             gap: 2,
//             flexWrap: 'wrap',
//             mb: 4,
//           }}
//         >
//           <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//             <InputLabel>Institution</InputLabel>
//             <Select
//               name="institution"
//               value={filters.institution}
//               onChange={handleFilterChange}
//               label="Institution"
//             >
//               <MenuItem value="">All</MenuItem>
//               {filterOptions.institutions.map((option) => (
//                 <MenuItem key={option} value={option}>
//                   {option}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//           <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//             <InputLabel>Field of Study</InputLabel>
//             <Select
//               name="field_of_study"
//               value={filters.field_of_study}
//               onChange={handleFilterChange}
//               label="Field of Study"
//             >
//               <MenuItem value="">All</MenuItem>
//               {filterOptions.fieldsOfStudy.map((option) => (
//                 <MenuItem key={option} value={option}>
//                   {option}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//           <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//             <InputLabel>Graduation Year</InputLabel>
//             <Select
//               name="graduation_year"
//               value={filters.graduation_year}
//               onChange={handleFilterChange}
//               label="Graduation Year"
//             >
//               <MenuItem value="">All</MenuItem>
//               {filterOptions.graduationYears.map((option) => (
//                 <MenuItem key={option} value={option}>
//                   {option}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//           <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//             <InputLabel>Status</InputLabel>
//             <Select
//               name="status"
//               value={filters.status}
//               onChange={handleFilterChange}
//               label="Status"
//             >
//               <MenuItem value="">All</MenuItem>
//               {filterOptions.statuses.map((option) => (
//                 <MenuItem key={option} value={option}>
//                   {option}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Box>
//         <Box sx={{ height: 600, width: '100%' }}>
//           {loading ? (
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 height: '100%',
//               }}
//             >
//               <CircularProgress />
//             </Box>
//           ) : (
//             <DataGrid
//               rows={filteredRows}
//               columns={columns}
//               pageSize={pageSize}
//               onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
//               rowsPerPageOptions={[5, 10, 20]}
//               pagination
//             />
//           )}
//         </Box>
//       </Container>
//       <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
//         <DialogTitle>{`${action === 'accept' ? 'Accept' : 'Deny'} Participant`}</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to {action} {selectedParticipant?.full_name}?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
//           <Button onClick={handleConfirmAction} autoFocus>
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: '100%' }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </ThemeProvider>
//   );
// }

// export default Student;

import React, { useState, useEffect } from 'react';
import {
  ThemeProvider,
  createTheme,
  Box,
  Typography,
  Container,
  CssBaseline,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import * as XLSX from 'xlsx';
import axios from 'axios';

const theme = createTheme({
  palette: {
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function Student() {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [filters, setFilters] = useState({
    institution: '',
    field_of_study: '',
    graduation_year: '',
    status: '',
  });
  const [filterOptions, setFilterOptions] = useState({
    institutions: [],
    fieldsOfStudy: [],
    graduationYears: [],
    statuses: [],
  });
  const [pageSize, setPageSize] = useState(10);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedParticipants, setSelectedParticipants] = useState([]);
  const [action, setAction] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        'https://newbackend.elephant-tank.com/api/verified_students/'
      );
      const formattedData = response.data
        .filter((item) => item.admin_approval === false)
        .map((item, index) => ({
          id: item.student_id, // Use student_id as the unique identifier
          serial_number: index + 1, // Add serial number for display purposes
          ...item,
        }));

      const institutions = [...new Set(formattedData.map((item) => item.institution))];
      const fieldsOfStudy = [...new Set(formattedData.map((item) => item.field_of_study))];
      const graduationYears = [...new Set(formattedData.map((item) => item.graduation_year))];
      const statuses = [...new Set(formattedData.map((item) => item.status || ''))];

      setRows(formattedData);
      setFilteredRows(formattedData);
      setFilterOptions({
        institutions,
        fieldsOfStudy,
        graduationYears,
        statuses,
      });
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setSnackbarMessage('Error fetching data. Please try again.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const applyFilters = () => {
      let filtered = rows;
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          filtered = filtered.filter((row) => row[key]?.toString() === value.toString());
        }
      });
      setFilteredRows(filtered);
    };

    applyFilters();
  }, [filters, rows]);

  const handleAction = (actionType) => {
    if (selectedParticipants.length === 0) {
      setSnackbarMessage('Please select at least one participant.');
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
      return;
    }
    setAction(actionType);
    setDialogOpen(true);
  };

  const handleConfirmAction = async () => {
    try {
      const endpoint = 'https://newbackend.elephant-tank.com/api/students_approval/';
      const payload = {
        student_id: selectedParticipants.map((participant) => participant.id),
        status: action,
      };

      const response = await axios.patch(endpoint, payload);

      if (response.status === 200) {
        const updatedRows = rows.map((row) => {
          if (selectedParticipants.some((participant) => participant.id === row.id)) {
            return { ...row, status: action };
          }
          return row;
        });

        setRows(updatedRows);
        setFilteredRows(updatedRows);
        setDialogOpen(false);

        setSnackbarMessage(response.data.msg || 'Student status updated successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setSelectedParticipants([]);
      } else {
        throw new Error('Unexpected response status');
      }
    } catch (error) {
      console.error('Error updating student status:', error);
      setSnackbarMessage('Error updating student status. Please try again.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Students');
    XLSX.writeFile(workbook, 'Verified_Students.xlsx');
  };

  const handleIndividualAction = async (row, actionType) => {
    try {
      const endpoint = 'https://newbackend.elephant-tank.com/api/students_approval/';
      const payload = {
        student_id: [row.id],
        status: actionType,
      };

      const response = await axios.patch(endpoint, payload);

      if (response.status === 200) {
        const updatedRows = rows.map((r) =>
          r.id === row.id ? { ...r, status: actionType } : r
        );

        setRows(updatedRows);
        setFilteredRows(updatedRows);

        setSnackbarMessage(response.data.msg || `Student ${actionType} successfully.`);
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
      } else {
        throw new Error('Unexpected response status');
      }
    } catch (error) {
      console.error(`Error ${actionType}ing student:`, error);
      setSnackbarMessage(`Error ${actionType}ing student. Please try again.`);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const columns = [
    { field: 'serial_number', headerName: 'S.No.', width: 100 },
    // { field: 'student_id', headerName: 'Student ID', width: 150 },
    { field: 'full_name', headerName: 'Full Name', flex: 1, minWidth: 150 },
    { field: 'email', headerName: 'Email', flex: 1, minWidth: 200 },
    { field: 'phone_number', headerName: 'Phone Number', flex: 1, minWidth: 150 },
    { field: 'institution', headerName: 'Institution', flex: 1, minWidth: 150 },
    { field: 'field_of_study', headerName: 'Field of Study', flex: 1, minWidth: 150 },
    { field: 'graduation_year', headerName: 'Graduation Year', flex: 1, minWidth: 120 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 200,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={() => handleIndividualAction(params.row, 'accept')}
          >
            Accept
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            size="small"
            onClick={() => handleIndividualAction(params.row, 'denied')}
          >
            Deny
          </Button>
        </Box>
      ),
    },
    { field: 'status', headerName: 'Status', flex: 1, minWidth: 120 },
   
  ];

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold', color: '#37474f' }}>
          Verified Students Dashboard
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Institution</InputLabel>
              <Select
                name="institution"
                value={filters.institution}
                onChange={handleFilterChange}
                label="Institution"
              >
                <MenuItem value="">All</MenuItem>
                {filterOptions.institutions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Field of Study</InputLabel>
              <Select
                name="field_of_study"
                value={filters.field_of_study}
                onChange={handleFilterChange}
                label="Field of Study"
              >
                <MenuItem value="">All</MenuItem>
                {filterOptions.fieldsOfStudy.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Graduation Year</InputLabel>
              <Select
                name="graduation_year"
                value={filters.graduation_year}
                onChange={handleFilterChange}
                label="Graduation Year"
              >
                <MenuItem value="">All</MenuItem>
                {filterOptions.graduationYears.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Status</InputLabel>
              <Select
                name="status"
                value={filters.status}
                onChange={handleFilterChange}
                label="Status"
              >
                <MenuItem value="">All</MenuItem>
                {filterOptions.statuses.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Button variant="contained" color="primary" onClick={handleDownloadExcel}>
            Download Excel
          </Button>
        </Box>
        <Box sx={{ height: 600, width: '100%' }}>
          {loading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <DataGrid
              rows={filteredRows}
              columns={columns}
              // checkboxSelection
              onSelectionModelChange={(newSelection) => {
                const selected = newSelection.map((id) =>
                  filteredRows.find((row) => row.id === id)
                );
                setSelectedParticipants(selected.filter(Boolean));
              }}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[5, 10, 20]}
              pagination
            />
          )}
        </Box>
        <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleAction('accept')}
          >
            Accept Selected
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => handleAction('denied')}
          >
            Deny Selected
          </Button>
        </Box>
      </Container>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>{`Confirm ${action === 'accept' ? 'Acceptance' : 'Denial'}`}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to {action} the selected participants?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleConfirmAction} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
}

export default Student;